module.exports = __webpack_public_path__ + "任景信-d00482ee.png";